import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE, isAppLanguage, type AppLanguage } from './index';

/** Current UI language as a narrow type; re-renders the caller when the language changes. */
export function useLang(): AppLanguage {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage ?? i18n.language;
  return isAppLanguage(language) ? language : DEFAULT_LANGUAGE;
}
